import * as Eta from 'eta';

Eta.defaultConfig.varName = 'ctx';
Eta.defaultConfig.autoEscape = true;

export default Eta;